<template>
	<c-window ref="window" :title="false" width="400" mask-close>
		<div class="list" :style="{'max-height': listHeight + 'px'}">
			<data-sort-config ref="dataSort" class="flex-column"></data-sort-config>
		</div>

		<template #foot>
			<div class="flex-end" style="width: 100%; margin-right: 5px;">
				<c-checkbox v-model="save">保存排序规则</c-checkbox>
			</div>
		</template>

		<template #button>
			<c-button @click="$refs.dataSort.reset()">重置</c-button>
			<c-button color="main" @click="submitHandle">确定</c-button>
		</template>
	</c-window>
</template>

<script>
	import dataSortConfig from './data_sort.vue'

	export default {
		name: 'dataSort',

		components: {
			dataSortConfig
		},

		props: {
			workType: [Number, String],
			viewId: [Number, String]
		},

		data() {
			let storage = JSON.parse(localStorage.getItem(this.workType) || '{}');
			return {
				save: !!storage.ds,
				listHeight: 0
			}	
		},

		methods: {
			open({follow, config}) {
				let rect = (follow.$el || follow).getBoundingClientRect();
				this.listHeight = Math.min(500, window.innerHeight - rect.bottom - 50);
				this.$refs.dataSort.set(this.workType, config || []);
				this.$refs.window.open(follow);
			},

			submitHandle() {
				let config = this.$refs.dataSort.get();
				this.$emit('resolve', config, this.save);
				this.$refs.window.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.list {
		max-height: 500px;
		overflow: auto;
	}

	>>> .c-form {
		padding-right: 10px;

		.sort-item:nth-child(n+2),
		.sort-item:nth-last-child(n+2) {
			margin-left: -10px;
		}

		.c-select {
			height: 32px;
		}
	}
</style>
